export default __webpack_public_path__ + "static/media/overview 1.f65b9b4a.svg";